import type { ChatMessage } from './chatTypes';

export const CHAT_HISTORY_LIMIT = 100;

export function pruneChatHistory(messages: ChatMessage[], limit = CHAT_HISTORY_LIMIT): ChatMessage[] {
  return messages.length > limit ? messages.slice(-limit) : messages;
}